export default "__VITE_ASSET__febaa90d__"